import React from "react";
import { authHeader } from "../_helpers";
import "react-light-accordion/demo/css/index.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactExport from "react-data-export";
import SideMenu from './SideMenu';
import Header from './Header';

class UploadResult extends React.Component {

  constructor() {
    super();
    this.state = {
      listOfQuizResultNotUploaded: [],
      selectedQuizId: -1
    }
    this.onFileUploadResult = this.onFileUploadResult.bind(this);
    this.onFileChangeResult = this.onFileChangeResult.bind(this);
  }

  state = {
    selectedResultFile: null
  };

  componentDidMount() {
    this.getQuizListResultNotUploaded();
  }

  getQuizListResultNotUploaded = () => {
    let user = JSON.parse(localStorage.getItem("user"));
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + user.data.accessToken,
    };
    let url = `http://15.206.132.121:3002/api/getQuizListResultNotUploaded`;
    fetch(url, { headers })
      .then((response) => response.json())
      .then((data) => {
        this.setState({ listOfQuizResultNotUploaded: data.data });
      })
      .catch((err) => {
        toast.error("Error! Please try again", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  };

  onFileChangeResult(e) {
    this.setState({ selectedResultFile: e.target.files[0] });
  }

  handleChange = (event) => {
    event.persist();
    this.setState({
      selectedQuizId: event.target.value,
    });
  };

  onFileUploadResult = event => {
    event.preventDefault();
    if (this.state.selectedResultFile && this.state.selectedQuizId !== -1) {
      var selectedQuiz = this.state.listOfQuizResultNotUploaded
        .find(item => item.QuizID === parseInt(this.state.selectedQuizId));

      if (this.state.selectedResultFile.name.slice(0, -5).toLowerCase() === selectedQuiz.QuizName.toLowerCase()) {
        let file = this.state.selectedResultFile;
        let filename = this.state.selectedResultFile.name;
        const data = new FormData();
        data.append("file", file);
        data.append("filename", filename);
        const requestOptions = {
          method: "POST",
          headers: authHeader(),
          body: data
        };
        let url = "http://15.206.132.121:3002/api/quizResultData";
        return fetch(url, requestOptions)
          .then(response => response.json())
          .then(data => {
            if (!data.success) {
              toast.error(data.message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined
              });
            } else {
              toast.success("File uploaded successfully", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined
              });
            }
          })
          .catch(err =>
            toast.error(err, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined
            })
          );
      } else {
        toast.error("The file chosen and Quiz name doesn't match! Please select correct Quiz Result file.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });
      }
    } else {
      toast.error("Please choose file to upload and select Quiz", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
      });
    }
  };

  onChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  render() {
    const ExcelFile = ReactExport.ExcelFile;
    const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
    const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
    let user = JSON.parse(localStorage.getItem("user"));
    return (
      <div>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <section id="container">

          <Header />

          <SideMenu />

          <section id="main-content">
            <section className="wrapper">
              <div className="nav notify-row" id="top_menu">
                <ul className="nav top-menu">
                  <li className="dropdown">
                    <div className="form-group">
                      <div className="col-lg-6">
                        <select
                          className="form-control"
                          id="source"
                          onChange={this.handleChange}
                          style={{ width: "250px" }}>
                          <option value="-1">Select Quiz </option>
                          {this.state.listOfQuizResultNotUploaded &&
                            this.state.listOfQuizResultNotUploaded.map((quiz, index) => {
                              return (
                                <option key={quiz.QuizID} value={quiz.QuizID}>
                                  {quiz.QuizName}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>


              <div className="input-group file-upload-group container">
                <span style={{ display: "flex" }} className="ml-3">
                  <input
                    type="file"
                    id="myfile"
                    name="myfile"
                    onChange={this.onFileChangeResult}
                  />
                  <button
                    className="btn btn-primary"
                    onClick={this.onFileUploadResult}
                  >
                    Upload
                        </button>
                        &nbsp;
                        <ExcelFile
                    element={
                      <button className="btn btn-primary">
                        Download Sample Excel
                            </button>
                    }
                  >
                    <ExcelSheet data={[]} name="Sample Result Excel">
                      <ExcelColumn label="Name" value="name" />
                      <ExcelColumn label="RollNo" value="rollno" />
                      <ExcelColumn label="Email" value="email" />
                      <ExcelColumn label="Physics Marks" value="pmarks" />
                      <ExcelColumn label="Physics Rank" value="prank" />
                      <ExcelColumn
                        label="Chemistry Marks"
                        value="cmarks"
                      />
                      <ExcelColumn label="Chemistry Rank" value="crank" />
                      <ExcelColumn label="Total Marks" value="tmarks" />
                      <ExcelColumn label="Total Rank" value="trank" />
                    </ExcelSheet>
                  </ExcelFile>
                </span>
              </div>
            </section>
          </section>
        </section>
      </div>
    );
  }
}

export default UploadResult;
